import styled from 'styled-components';

import tickIcon from '~/assets/icons/tick.svg';

const Checkbox = styled.input.attrs({
	type: 'checkbox',
})`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	margin: 0;
	margin-right: 10px;
	appearance: none;
	border-width: 0;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.05);
	transition: background-color 0.25s ease;
	cursor: pointer;
	user-select: none;

	&::before {
		content: '';
		display: flex;
		margin: auto;
		width: 14px;
		height: 14px;
		mask-image: url(${tickIcon});
		mask-position: center;
		mask-repeat: no-repeat;
		-webkit-mask-image: url(${tickIcon});
		-webkit-mask-position: center;
		-webkit-mask-repeat: no-repeat;
		background-color: #fff;
		opacity: 0;
		transition: opacity 0.25s ease;
	}

	&:checked {
		background-color: #1782ff;

		&::before {
			opacity: 1;
		}
	}
`;

export { Checkbox };
